import { ReactElement } from 'react'
import styled from 'styled-components'
import Card from 'react-bootstrap/Card'
import { CardGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { weight } from '../../../../const/fonts'
import { H3, Small, Body } from '../../../../typography'
import theme, { colors } from '../../../../const/theme'

interface UpComingSessionCardProps {
  subject: string
  session: string
  date: string
  time: string
  index: number
}

export const Text = styled(Small)`
  color: ${theme.disabled};
  width: 6rem;
  padding: 0;
  font-weight: ${weight.bold};
`

const CardGroupWrapper = styled(CardGroup)`
  margin: 1rem;
`

const CardItem = styled(Card)`
  flex-direction: column;
  padding: 1rem;
`

const CardWrapper = styled.div`
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
`

const SessionTitle = styled(Small)`
  padding: 0;
`

const CardBody = styled(Card.Body)`
  padding: 0px;
`

export const UpComingSessionCard = ({
  subject,
  session,
  date,
  time
}: UpComingSessionCardProps): ReactElement => {
  return (
    <CardGroupWrapper>
      <CardItem>
        <CardBody>
          <H3>{subject}</H3>
          <SessionTitle color={colors.gray}>{session}</SessionTitle>
          <CardWrapper>
            <FontAwesomeIcon
              icon={['far', 'calendar-alt']}
              style={{ marginRight: 10 }}
            />
            <Body>{date}</Body>
          </CardWrapper>
          <CardWrapper>
            <FontAwesomeIcon
              icon={['far', 'clock']}
              style={{ marginRight: 10 }}
            />
            <Body>{time}</Body>
          </CardWrapper>
        </CardBody>
      </CardItem>
    </CardGroupWrapper>
  )
}
